import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardHeader, CardTitle, Input } from '@monigo/ui';
import { Logo } from '../../components/Brand/Logo.js';
import { supabase } from '../../lib/supabase.js';

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <div className="container max-w-md py-12">
      <div className="mb-8 flex justify-center">
        <Logo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>{t('auth.title')}</CardTitle>
        </CardHeader>
        <form
          className="flex flex-col gap-3"
          onSubmit={async (e) => {
            e.preventDefault();
            setError(null);
            setLoading(true);
            const { error: err } = await supabase.auth.signInWithPassword({ email, password });
            setLoading(false);
            if (err) {
              setError(t('auth.errors.invalid'));
              return;
            }
            navigate('/', { replace: true });
          }}
        >
          <label className="flex flex-col gap-1 text-sm">
            <span className="text-text-muted">{t('auth.email')}</span>
            <Input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="flex flex-col gap-1 text-sm">
            <span className="text-text-muted">{t('auth.password')}</span>
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error ? <p className="text-sm text-danger">{error}</p> : null}
          <Button type="submit" isLoading={loading}>
            {t('auth.loginCta')}
          </Button>
        </form>
      </Card>
    </div>
  );
}
